import { type To, type NavigateOptions, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { ButtonText } from '@percent/lemonade'

export type SeeAllBtnProps = Readonly<{
  href: To
  navigateOptions?: NavigateOptions
}>

export function SeeAllBtn({ href, navigateOptions }: SeeAllBtnProps): JSX.Element {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <ButtonText onClick={() => navigate(href, ...(navigateOptions ? [navigateOptions] : []))}>
      {t('workplace_giving.common.seeAll')}
    </ButtonText>
  )
}
